import { TermsAndConditionsLink } from '@/components/features/common/TermsAndConditions';
import WrappedModal from '@/components/ui/WrappedModal';
import { Box } from '@mui/system';
import { Trans, useTranslation } from 'next-i18next';
import Link from 'next/link';

const SaturdayTAndC = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
}) => {
  const [t] = useTranslation();
  const termsConditions = [
    {
      text: `A single bonus can be earned when making a deposit on a Saturday. The qualifying deposit must be made as a single transaction.`,
    },
    {
      text: `
        20 free spins will be credited for a deposit between 20 USDT and 50 USDT <br />
        50 free spins will be credited for a deposit between 50 USDT and 100 USDT <br />
        100 free spins will be credited for a deposit of 100+ USDT and above`,
      components: {
        br: <Box sx={{ mb: 1 }}></Box>,
      },
    },
    {
      text: `Winnings obtained with the help of free spins have a x40 wagering requirement.`,
    },
    {
      text: `<tcLink>General Bonus Terms & Conditions</tcLink> must be observed.`,
      components: {
        tcLink: (
          <Link
            href="/help/general-bonuses-terms-conditions"
            style={{
              color: '#FFD939',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          />
        ),
      },
    },
    {
      text: `Free spins will be added to a slot game you pick from our list. This list is updated monthly.`,
    },
  ];
  return (
    <WrappedModal
      sxs={{
        wrapperSX: {
          width: { xs: '100%', md: '800px' },
        },
      }}
      open={showModal}
      onClose={() => setShowModal(false)}
      titleComp={
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          {t('TERMS & CONDITIONS (18+)')}
        </Box>
      }
    >
      <Box
        component={'ul'}
        padding={1}
        sx={{
          fontSize: '16px',
          lineHeight: '28px',
        }}
      >
        {termsConditions.map((item, index) => {
          return (
            <li key={index} style={{ marginTop: '10px' }}>
              <Trans i18nKey={t(item.text)} components={item.components} />
            </li>
          );
        })}
      </Box>
    </WrappedModal>
  );
};

export default SaturdayTAndC;
